import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Project } from "@models/project.model";

@Component({
  selector: "app-development-project-card",
  templateUrl: "./development-project-card.component.html",
  styleUrls: ["./development-project-card.component.scss"],
})
export class DevelopmentProjectCardComponent {
  isMultiProject = false;
  multiMultisiteProjectTitle = "Multisite Project";

  @Input()
  set project(project: Project) {
    this.projectStatus = [];
    this.budget = 0;
    this.fundingSource = [];
    this._project = project;
    this.getProjectstatus();
    this.getFundingSource();
    this.getBudget();
    this.isMultiProject = this._project.otherDevelopments.length > 1 ? true : false;
    // console.log(this.isMultiProject);
    
  }

  get project(): Project {
    return this._project;
  }

  @Output() closeModal = new EventEmitter<boolean>();

  projectStatus: string[] = [];

  budget = 0;

  fundingSource: string[] = [];
  _project!: Project;

  getProjectstatus(): void {
    this.projectStatus.push(this._project.projectStatus);

    this.projectStatus.push(
      ...this._project.schedule
        .filter((x) => Number(x.percentageCompleted) < 100 && Number(x.percentageCompleted) !== 0)
        .flatMap((v) => v.masterTaskName),
    );

    this.projectStatus = this.projectStatus.filter((item, pos, ar) => ar.indexOf(item) === pos);
  }

  getFundingSource(): void {
    this.fundingSource.push(...this._project.funding.flatMap((x) => x.fundingCategory));
    this.fundingSource = this.fundingSource.filter((item, pos, ar) => ar.indexOf(item) === pos);
  }

  getBudget(): void {
    // this.budget = this._project.funding
    //   .flatMap((x) => x.totalBudget)
    //   .reduce((acc, cur) => acc + Number(cur), 0);
    this.budget = this._project.projectTotalBudget;
  }

  triggerClose(): void {
    this.closeModal.emit(true);
  }
}
